import React from 'react';
import Utils from '../providers/Utils';
import {Avatar} from '@material-ui/core'
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types'

export default class GanttProiecteWeekView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        this.goToElement()
    }

    filterCuloareEtapa = (l) => {

     
        let filteredList = l.filter(i => i.statusul !== 'Finalizat')

        let taskuriTrecute = filteredList.filter(t => new Date(t.durata_pana_la) < new Date() )

        if(taskuriTrecute.length > 0){
            return'#ff3f3f'
        }else if (filteredList.length > 0){
           return 'rgb(247, 167, 16)'
        }else{
           return '#7ad13a'
        }

        

    }

    getLitereAvatar = (tx) => {



        if (tx !== null) {

            return tx.substring(0, 2)
        }
    }

    afiseazaData = (dataStart, dataFinish, limba, color) => {

        let u = new Utils()



        if (limba === 'en') {

            let _dataStart = dataStart !== null ? u.dataPrescurtataEng(dataStart) : this.props.dictionary.noData
            let _dataFinish = dataFinish !== null ? u.dataPrescurtataEng(dataFinish) : this.props.dictionary.noData

            let span = <span className='pm-gantt-task-date'>{_dataStart} - {_dataFinish} </span>
            return span


        } else {
            let _dataStart = dataStart !== null ? u.dataPrescurtataRomana(dataStart) : this.props.dictionary.noData
            let _dataFinish = dataFinish !== null ? u.dataPrescurtataRomana(dataFinish) : this.props.dictionary.noData

            let span = <span style={{ backgroundColor: color }} className='pm-gantt-task-date'>{_dataStart} - {_dataFinish} </span>

            return span
        }
    }

    goToElement =async () =>{


        await this.getDates()
  
         let u = new Utils()
  
         let date = u.dataPrescurtataEngNoYear(u.defaultData())
  
         if(new Date(this.props.objPerioadaGantt.dtPerioadaDeLa) > new Date() ){
  
          date = u.dataPrescurtataEngNoYear(this.props.objPerioadaGantt.dtPerioadaDeLa)
         }
  
          // console.log('date :', date);
        let data = document.getElementById(`#${date}`)
  
        data.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'})
  
      //  console.log('data :', data);
     }


    getWeekEndColor = (t,dt,p, fE) => {

    //   console.log('p :', p);
      let u = new Utils()

    

      let getStatusEtape = fE.filter(e => e.statusul !== 'Finalizat')


      let filterEtape = fE.filter(e => new Date(e.durata_de_la) <= new Date(dt) && new Date(dt) <= new Date(e.durata_pana_la))

    //   console.log('filterEtape :', filterEtape);

    //   console.log('dt :',new Date(dt));



     

      if(new Date(dt) >= new Date(p.perioada_dela) && new Date(dt) <= new Date(p.perioada_panala)){
                    if(u.transformDataForSql(dt) === u.defaultData()){
                        return 'repeating-linear-gradient(135deg, rgb(241, 241, 241), rgb(160, 143, 243) 0.25em, rgba(74, 36, 222, 0.53) 0px, rgba(16, 187, 187, 0.35) 0.3em)'
                    }else{
                    if (t === 0) {
                        return 'rgba(222, 222, 222, 0.37)'
                    } else if (t === 6) {
                        return 'rgba(222, 222, 222, 0.37)'
                    }
                    else if(filterEtape.length>0){
                        // console.log('new Date(filterEtape[0].durata_pana_la :', new Date(filterEtape[0].durata_pana_la))
                        if(filterEtape[0].statusul === 'Finalizat'){
                            return '#00800054'

                           
                        }else if(new Date(filterEtape[0].durata_pana_la) <= new Date()){
                            return '#ff000066'
                               
                        }else{
                            return '#ffa50054'
                        }
                    }
                    else if(getStatusEtape.length > 0){
                        if(new Date(p.perioada_panala)< new Date()){
                            return '#ff000066'
                        }else{
                            return '#ffa50054'
                        }
                    }else{
                        return '#00800054'
                    }
                }
        
      }else{

          if(u.transformDataForSql(dt) === u.defaultData()){
              return 'repeating-linear-gradient(135deg, rgb(241, 241, 241), rgb(160, 143, 243) 0.25em, rgba(74, 36, 222, 0.53) 0px, rgba(16, 187, 187, 0.35) 0.3em)'
          }else{
              if (t === 0) {
                  return 'rgb(228, 228, 228)'
              } else if (t === 6) {
                  return 'rgb(228, 228, 228)'
              } else {
                  return 'white'
              }
          }
      }
       

        
    }

    proiectClick = (p) =>{
        // console.log('p :', p);

        this.props.history.push(`/projectdetails/${p.id}/0`)
    }

    goToEtapa = (e) =>{
        // console.log('e :', e);

        let ls = new LocalStorage();

        ls.SetEtapaId(e)
        this.props.history.push(`/projectdetails/${e.id_proiect}/1`)

    }


    getDates = () => {

        let u = new Utils();

        let etapaHeight = 40

        let dataStartHead = new Date(this.props.objPerioadaGantt.dtPerioadaDeLa)
        let dataFinishHead = new Date(this.props.objPerioadaGantt.dtPerioadaPanaLa)

        // console.log('dataStartHead :', dataStartHead);

        // console.log('dataFinishHead :', dataFinishHead);

        let cloneEtape = [...this.props.listEtape]

        let cloneProjects = [...this.props.listProiecte]

        let counter = cloneProjects.length

        let container = []

        let projectContainer = []

        let head = []


        if (this.props.dictionary.date === 'en') {
            for (dataStartHead; dataStartHead <= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate() + 1)) {
                // let todayH = dataStartHead.getDay()
                head.push(<div  className='pm-gantt-head-item' key={u.dataPrescurtataRomana(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataEngNoYear(dataStartHead)}</div>)


            }
        }else{
            for(dataStartHead; dataStartHead<= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate()+1) ){
                // let todayH = dataStartHead.getDay()
                head.push(<div  className='pm-gantt-head-item' key={u.dataPrescurtataRomana(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataRomanaNoYear(dataStartHead)}</div>)
      
      
               }
               
        }

            for (let p = 0; p < counter; p++) {
                let body = []

                let etapaLength
                let dataStart = new Date(this.props.objPerioadaGantt.dtPerioadaDeLa)
                let dataFinish = new Date(this.props.objPerioadaGantt.dtPerioadaPanaLa)

                let culoare = ''

                for (dataStart; dataStart <= dataFinish; dataStart.setDate(dataStart.getDate() + 1)) {

                    let filterEtape = cloneEtape.filter(etp => etp.id_proiect === cloneProjects[p].id);


                    culoare = this.filterCuloareEtapa(filterEtape)
                    etapaLength = filterEtape.length

                    let counter2 = filterEtape.length

                    // console.log('filterEtape :', filterEtape);

                  

                    let etapa = []

                    for (let i = 0; i < counter2; i++) {
                            // console.log('u.tra :', u.transformDataForSql(dataStart));
                            // console.log('filterData :', filterEtape[i].durata_de_la);


                        if (u.transformDataForSql(dataStart) === filterEtape[i].durata_de_la) {

                            
                            let newFilter = filterEtape.filter(k => k.id !== filterEtape[i].id)

                            // console.log('newFilter :', newFilter);

                            // let idx = newFilter.findIndex(j => new Date(j.durata_pana_la) > new Date(filterEtape[i].durata_de_la))

                            // if (idx !== -1) {

                                
                            //     etapa.push(
                            //         <div key={i} id={'pm-gantt-item-id' + i} className='pm-task-gantt-item-container' style={{ height: etapaHeight, marginTop: (etapaHeight + 5) * (i + 1), width: (u.getDaysDifference(filterEtape[i].durata_de_la, filterEtape[i].durata_pana_la) * 101), position: 'relative' }}>
                            //             <div onClick={() => { this.goToEtapa(filterEtape[i]) }} className='pm-task-gantt-item' style={{ height: etapaHeight, backgroundColor: filterEtape[i].color }}><Avatar style={{ display: 'inline-flex' }} className='pm-avatar'>
                            //                 {this.getLitereAvatar(filterEtape[i].denumire + ' ')} </Avatar><span className='pm-gant-task-title'>{filterEtape[i].denumire}</span> {this.afiseazaData(filterEtape[i].durata_de_la, filterEtape[i].durata_pana_la, this.props.dictionary.data, filterEtape[i].color)} </div>
                            //             <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
                            //         </div>
                            //     )
                            // } else {

                                
                                etapa.push(
                                    <div key={i} id={'pm-gantt-item-id' + i} className='pm-task-gantt-item-container' style={{ height: etapaHeight, marginTop: (etapaHeight + 60), width: (u.getDaysDifference(filterEtape[i].durata_de_la, filterEtape[i].durata_pana_la) * 101), position: 'relative' }}>
                                        <div onClick={() => { this.goToEtapa(filterEtape[i]) }} className='pm-task-gantt-item' style={{ height: etapaHeight, backgroundColor: filterEtape[i].color}}><Avatar style={{ display: 'inline-flex' }} className='pm-avatar'>
                                            {this.getLitereAvatar(filterEtape[i].denumire + ' ')} </Avatar><span className='pm-gant-task-title'>{filterEtape[i].denumire}</span> {this.afiseazaData(filterEtape[i].durata_de_la, filterEtape[i].durata_pana_la, this.props.dictionary.data, filterEtape[i].color)}</div>
                                        <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
                                    </div>
                                )
                            // }
                        }
                    }

                    let today = dataStart.getDay()

                    // console.log('body.length :', etapa.length);

                    body.push(<div id={`${dataStart}`} style={{ background: this.getWeekEndColor(today, dataStart, cloneProjects[p], filterEtape) }} className='pm-gantt-body-item' key={u.dataPrescurtataEng(dataStart)} >{etapa}</div>)


                }
              if(etapaLength> 0){

             
                projectContainer.push(<div key={`project${p}`} style={{ height: '100%', borderBottom: '1px dashed gray', minHeight:150 }}>

                    <div className='pm-etapa-title'>

                        <div style={{ position: 'relative' }} onClick={() => { this.proiectClick(cloneProjects[p]) }} className='pm-list-container-etapa-gantt'>
                            <div style={{ backgroundColor: culoare }} className='pm-list-borderleft'></div>


                            <div className='pm-list-container-task-content'>

                                <span style={{ marginTop: 0, paddingTop: 12 }} className='pm-list-item-task'>{cloneProjects[p].titlu}</span>

                            </div>
                        </div>

                    </div>
                 
                    <div className='pm-gantt-body'>
                   
                        {body}
                    </div>


                </div>)
              }else{

              }

            }

            container  = 
    <div  style={{height:'100%'}}>
    <div className='pm-gantt-head'>
    {head} 
    </div> 

    {projectContainer}

    </div>
      




        return container

        
    }



    render() {
        return (
            <div className='pm-gant-container'>

                {
                    this.getDates()
                }

            </div>
        );
    }
}//end class


GanttProiecteWeekView.propType = {
    dictionary:PropTypes.object,
    objPerioadaGantt:PropTypes.object,
    listEtape:PropTypes.array,
    listProiecte:PropTypes.array,
    history:PropTypes.array
}